<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="14"
            categoryName="Controller"
            categorySectionIcon="fa-wrench"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'controller',
    components: { BaseInventory }
}
</script>
